import { useEffect, useReducer } from "react";
import GenericModal from "../CommonComponents/genericModal/GenericModal";

import styles from "./users-and-roles.module.css";
import { UserInvitationForm } from "./UserInvitationForm";
import { RegionSelection, SubregionSelection } from "./OrganizationSelection";


export const MODAL_ACTIONS = {
  SELECT_REGION: "SELECT_REGION",
  SELECT_SUBREGION: "SELECT_SUBREGION",
  INVITE_FORM: "INVITE_FORM",
}

const initialModalState = {
  inviteForm: true,
  regionSelection: false,
  subregionSelection: false,
  userId: null,
}

const modalReducer = (state, action) => {
  switch (action.type) {
    case MODAL_ACTIONS.SELECT_REGION:
      return { regionSelection: true, subregionSelection: false, userId: action.payload, inviteForm: false };
    case MODAL_ACTIONS.SELECT_SUBREGION:
      return { regionSelection: false, subregionSelection: true, userId: action.payload, inviteForm: false };
    case MODAL_ACTIONS.INVITE_FORM:
      return {regionSelection: false, subregionSelection: false, inviteForm: true, userId: null };
    default:
      return state;
  }
}

export const USER_ACTIONS = {
  ADD_USER: "ADD_USER",
  UPDATE_USER: "UPDATE_USER", 
  DELETE_USER: "DELETE_USER",
  RESET_USERS: "RESET_USERS"
}

const createNewUser = () => ({
  id: Date.now() + Math.random(),
  name: "",
  email: "",
  roleId: null,
  administratorLevel: null,
  accessId: null,
});

const userReducer = (state, action) => {
  switch (action.type) {
    case USER_ACTIONS.ADD_USER:
      return [...state, createNewUser()];
    
    case USER_ACTIONS.UPDATE_USER:
      return state.map(user => 
        user.id === action.payload.id ? action.payload.user : user
      );
    
    case USER_ACTIONS.DELETE_USER:
      return state.length > 1 
        ? state.filter(user => user.id !== action.payload.id)
        : state;
    
    case USER_ACTIONS.RESET_USERS:
      return [createNewUser()];
    
    default:
      return state;
  }
}

const UserInvitationModal = ({
  open,
  onClose,
  onInvitationsSent,
  onInvitationSendError,
}) => {
  const [modalState, modalDispatch] = useReducer(modalReducer, initialModalState);

  const [users, usersDispatch] = useReducer(userReducer, [createNewUser()]);

  useEffect(() => {
    if (open) {
      usersDispatch({ type: USER_ACTIONS.RESET_USERS });
    }
  }, [open]);



  const handleClose = () => {
    setTimeout(() => {
      modalDispatch({ type: MODAL_ACTIONS.INVITE_FORM });
    }, 100);
    onClose();
  }

  const handleInvitationsSent = () => {
    handleClose();
    onInvitationsSent?.();
  };

  const handleInvitationSendError = (error) => {
    const errorMessage = error?.data?.errorMessage || "Failed to send invitations";
    onInvitationSendError?.(errorMessage);
  };
  
  const selectedUser = users.find(user => user.id === modalState.userId);

  return (
    <GenericModal open={open} onClose={handleClose} backdropClassName={styles.modalBackdrop} modalClassName={styles.inviteModal}>
      {modalState.inviteForm && (
        <UserInvitationForm
          onClose={handleClose}
          users={users}
          usersDispatch={usersDispatch}
          modalDispatch={modalDispatch}
          onInvitationsSent={handleInvitationsSent}
          onInvitationSendError={handleInvitationSendError}
        />
      )}
      {modalState.regionSelection && <RegionSelection onClose={handleClose} user={selectedUser} modalDispatch={modalDispatch} usersDispatch={usersDispatch} />}
      {modalState.subregionSelection && <SubregionSelection onClose={handleClose} user={selectedUser} modalDispatch={modalDispatch} usersDispatch={usersDispatch} />}
    </GenericModal>
  )
}
export default UserInvitationModal;
